/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Extract_DataInputs */



/**
* | output |
* | --- |
* | "Extract data from documents" |
*
* @param {Onboarding_Usage_Extract_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_extract_data = /** @type {((inputs?: Onboarding_Usage_Extract_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Extract_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Daten aus Dokumenten extrahieren")
	return /** @type {LocalizedString} */ ("Extract data from documents")
});